import { Alert } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

interface ErrorAlertProps {
  message: string;
  onClose?: () => void;
  showIcon?: boolean;
  closable?: boolean;
  style?: React.CSSProperties;
}

/**
 * Error Alert Component
 * Displays error messages with consistent styling
 */
export const ErrorAlert = ({ 
  message, 
  onClose, 
  showIcon = true, 
  closable = true,
  style 
}: ErrorAlertProps) => {
  return (
    <Alert
      message="Error"
      description={message}
      type="error"
      showIcon={showIcon}
      closable={closable}
      onClose={onClose}
      icon={<CloseCircleOutlined />}
      style={{
        marginBottom: 16,
        ...style,
      }}
    />
  );
};
